/* global WC */
import ButtonUrl from '@shared-vue-components/components/asiagoit-buttons/ButtonUrl.vue'
import {NConfigProvider} from 'naive-ui'
import {createApp, h} from 'vue'
import {getSeasonColors} from '~/default/scripts/utils/generic'

const minisite = WC.PageVars.minisites?.at(0)
const colors = getSeasonColors()

if (minisite) {
  const elements = document.querySelectorAll('[data-cms-vue-component="asiagoit-button-url"]')

  const createVueApp = (url, text) =>
    createApp({
      setup() {
        return () =>
          h(
            NConfigProvider,
            {
              preflightStyleDisabled: true,
              themeOverrides: {
                common: {
                  primaryColor: colors.main,
                  primaryColorHover: colors.lighter,
                  primaryColorPressed: colors.main,
                  primaryColorSuppl: colors.darker,
                },
              },
            },
            h(ButtonUrl, {text, url})
          )
      },
    })

  const apps = Array.from(elements).map(element => ({
    app: createVueApp(element.getAttribute('data-url'), element.getAttribute('data-text')),
    element,
  }))

  document.addEventListener('cmsVueComponentsReady', () => {
    apps.forEach(({app, element}) => {
      app.mount(element)
    })
  })
}
